;(function () {
    window.Ateed.Components.Footer = function() {
      function getAteedCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
      }
      function ateedSetCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = 0;
        if (exdays!=0) {
          expires = "expires="+ d.toUTCString();
        }
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }

      if ($('.ateed-language-options.form-control').length > 0) {
        if (getAteedCookie('lang')!='') {
          $('.ateed-language-options.form-control').val(getAteedCookie('lang'));
        }

        $('.ateed-language-options.form-control').on('change',function(e){
          e.preventDefault();
          $.ajax({
              url: $('option:selected',$(this)).attr('data-url'),
              type: 'GET',
              async: true,
              dataType: "json",
              cache: false,
              crossDomain: true,
              xhrFields: {
                  withCredentials: true
              },
              success: function(data){
                if (data) {
                  if (data.url && data.langcode) {
                    //$.cookie('lang',data.langcode, { expires: 7, path: '/' });
                    ateedSetCookie('lang',data.langcode,7);
                    window.location = data.url;
                  }
                }
              }
          });
        });
      }
    };
})();
